import { Component, OnInit } from '@angular/core';
import { Router } from '@angular/router';
import {ViewUser} from '../models/user';

import { AuthService } from '../providers/auth.service';
import { Ng4LoadingSpinnerService } from 'ng4-loading-spinner';
import { environment } from '../../environments/environment.prod';
@Component({
  selector: 'app-view-profile',
  templateUrl: './view-profile.component.html',
  styleUrls: ['./view-profile.component.css']
})
export class ViewProfileComponent implements OnInit {
  public userData:ViewUser = {first_name: null, last_name: null, email: null, country_code: null, phone: null, street_address: null, apt: null, cross_street: null, area_name: null};
  constructor(private auth : AuthService, private router: Router, private spinnerService: Ng4LoadingSpinnerService) { }

  ngOnInit() {
    this.spinnerService.show();
    let sid = localStorage.getItem('sid');
    this.auth.my_account({"sid":sid}).then((user) => {
      console.log(user.json());
      let response = user.json();
      if(response.replyCode == "error"){
        this.spinnerService.hide();
        this.auth.open(response.replyMsg);
      }else{
        this.userData = user.json().data;
        this.spinnerService.hide();
        console.log("userData", this.userData)
      }
    })
    .catch((err) => {
      this.spinnerService.hide();
      console.log(err);
      this.auth.open(environment.error)
    });
  }

  logout(){
    this.auth.changeLoginStatus(false);
    localStorage.removeItem('token');
    localStorage.removeItem('currentUser');
    localStorage.removeItem('sid');
    this.router.navigate(['/']);
 }
 edit_profile(){
    this.router.navigate(['edit-profile']);
 }

}



// WEBPACK FOOTER //
// D:/xampp/htdocs/laundry-pickup/laundry-pickup-website/src/app/view-profile/view-profile.component.ts